<template>
  <div class="OrderDetail">
    <div class="detail-group">
      <div class="pay-type">
        {{details.State}}
        <p>订单编号：{{Code}}</p>
      </div>
      <div class="user-info">
      <span class="Headimg">
        <img :src="details.BizMemberInfo.Headimgurl" alt="" v-if="details.BizMemberInfo.Headimgurl">
        <span v-else style="font-size: 12px;color: #999;">暂无<br />头像</span>
      </span>
        <div class="info">
          <p>{{details.BizMemberInfo.Name}} <strong>{{details.BizMemberInfo.Mobile}}</strong></p>
          <!--<div><strong>{{details.BizMemberInfo.RegionName}}</strong> {{details.BizMemberInfo.FullAddress ? details.BizMemberInfo.FullAddress.substr(0, details.BizMemberInfo.FullAddress.length - 1) : details.BizMemberInfo.FullAddress}}</div>-->
          <div><strong>{{details.BizDormitoryInfo.RegionName}}</strong> {{details.BizDormitoryInfo.FullAddress}}</div>
        </div>
      </div>
    </div>
    <equipment-detail v-if="BizOrderPackageInfo" class="detail-group" :details="Object.assign(BizOrderPackageInfo, {ValidityEndTimeStr: ValidityEndTimeStr})"></equipment-detail>
    <div class="Remarks detail-group">
      <p>备 注</p>
      <div>
        {{details[$route.query.type === '退租'? 'Msg': 'Text']}}
      </div>
    </div>
    <div class="detail-group">
      <tr-steps :data="orderFlow" :active="0"></tr-steps>
    </div>
  </div>
</template>

<script>
  import trSteps from '@/components/trSteps'
  export default {
    name: 'repairDetails',
    data() {
      return {
        orderFlow:[],
        Code: '',
        ValidityEndTimeStr: '',
        BizOrderPackageInfo: {
          Price: 0,
          Deposit: 0
        },
        Id: '',
        details: {
          BizDormitoryInfo: {},
          BizMemberInfo: {
            Headimgurl: ''
          }
        }
      }
    },
    components: {
      trSteps
    },
    methods: {
      getOrderFlow() {
        let url = ''
        let params = {}
        if(this.$route.query.type === '报修') {
          url = '/BizMemberServiceFlow/AllList'
          params.ServiceId = this.$route.query.Id
        } else {
          url = '/BizMemberReturnFlow/AllList'
          params.ReturnId = this.$route.query.Id
        }
        this.$post(url, params).then(res => {
          if(res) {
            this.orderFlow = res.Data
          }
        })
      },
      getDetail() {
        let url;
        if(this.$route.query.type === '退租') {
          url = '/BizMemberReturn/Details'
        } else {
          url = '/BizMemberService/Details'
        }
        this.$toast.loading({
            mask: true,
            message: '加载中...'
        });
        this.$post(url, {Id: this.$route.query.Id}).then(res => {
          if(res) {
            this.details = res.Data
            this.getOrderDetails(res.Data.OrderId)
          }
        })
      },
      getOrderDetails(id) {
        this.$post('/BizMemberOrder/Details', {Id: id}).then(res => {
          if(res) {
            this.$toast.clear()
            this.Code = res.Data.Code
            this.ValidityEndTimeStr = res.Data.EndTimeStr
            this.BizOrderPackageInfo = res.Data.BizOrderPackageInfo
            console.log(this.BizOrderPackageInfo)
          }
        })
      }
    },
    mounted() {
      this.getDetail()
      this.getOrderFlow()
    }
  }
</script>

<style scoped lang="less">
  .user-info{
    margin-bottom: 10px;
    display: flex;
    background: #fff;
    padding: 10px;
    position: relative;
    .Headimg{
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      overflow: hidden;
      font-size: 16px;
      width: 45px;
      height: 45px;
      margin-right: 10px;
      img{
        width: 110%;
      }
    }
    time{
      position: absolute;
      right: 10px;
      top: 13px;
      color: #999;
      font-size: 14px;
    }
    .info{
      p{
        margin: 0;
        font-size: 14px;
        margin-bottom: 5px;
        strong{
          margin-left: 5px;
          font-size: 12px;
          font-weight: normal;
          color: #999;
        }
      }
      div{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        font-size: 14px;
        color: #999;
        strong{
          font-weight: normal;
          font-size: 18px;
          color: #666;
        }
      }
    }
  }
  .pay-type{
    background: #468bea;
    height: 80px;
    font-size: 20px;
    color: #fff;
    padding: 10px;
    p{
      font-size: 12px;
      margin: 0;
      margin-top: 10px;
    }
  }
  .Remarks{
    margin-top: 15px;
    background: #fff;
    p{
      margin: 0;
      padding: 10px 15px;
    }
    >div{
      padding: 0 15px 10px 15px;
      color: #666;
    }
  }
</style>
